module.exports = __webpack_public_path__ + "img/0220623112142.32df0cf3.png";